import React from 'react';

import { createRouter as createTanstackRouter } from '@tanstack/react-router';

import NotFound from './pages/NotFound';
import { RootLayout } from './routes/__root';
import { routeTree } from './routeTree.gen';

export default function createRouter(): ReturnType<typeof createTanstackRouter> {
  return createTanstackRouter({
    routeTree,
    scrollRestoration: false,
    defaultPreload: 'intent',
    defaultNotFoundComponent: () => <RootLayout><NotFound /></RootLayout>,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof createRouter;
  }
}
